import React, { useState, useEffect } from 'react';
import './CadastrarContrato.css';
import { message } from 'antd';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const initialState = {
  prefeitura: '',
  valorContrato: '', // Armazenaremos o valor como string formatada para exibição
  valorContratoNumeric: 0, // Armazenaremos o valor numérico real aqui
  DESCONTO: '',         // novo campo
  descricao: '',           // novo campo
};

// Função para formatar valor como moeda BRL
const formatCurrency = (value) => {
  // Remove todos os caracteres que não são dígitos
  let cleanedValue = value.replace(/\D/g, '');

  // Converte para número e divide por 100 para obter centavos
  let numberValue = parseFloat(cleanedValue) / 100;

  // Se o valor for NaN (empty string case), retorna string vazia
  if (isNaN(numberValue)) {
    return '';
  }

  // Formata o número como moeda BRL
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numberValue);
};

// Função para converter valor formatado para numérico
const parseCurrency = (value) => {
    // Remove R$, pontos de milhar e substitui vírgula por ponto decimal
    let numericValue = value.replace(/[^0-9,-]/g, '').replace(',', '.');
    return parseFloat(numericValue) || 0;
};

export default function CadastrarContrato() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [prefeituras, setPrefeituras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPrefeituras, setLoadingPrefeituras] = useState(false);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  useEffect(() => {
    carregarPrefeituras();
  }, []);

  const carregarPrefeituras = async () => {
    try {
      setLoadingPrefeituras(true);
      const response = await api.get(API_CONFIG.ENDPOINTS.PREFEITURA.CONSULTAR_PREFEITURA);
      
      if (response.data.status) {
        const prefeiturasFormatadas = response.data.prefeituras.map(pref => ({
          id: pref.PRE_ID,
          nome: pref.PRE_NOME
        }));
        setPrefeituras(prefeiturasFormatadas);
      } else {
        message.error('Erro ao carregar prefeituras');
      }
    } catch (error) {
     // console.error('Erro ao carregar prefeituras:', error);
      message.error('Erro ao carregar prefeituras');
    } finally {
      setLoadingPrefeituras(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'valorContrato') {
      // Remove caracteres não numéricos para formatar
      const numericValue = parseCurrency(formatCurrency(value));
      const formattedValue = formatCurrency(value);

      setForm({ 
        ...form, 
        [name]: formattedValue, // Armazena string formatada para exibição
        valorContratoNumeric: numericValue // Armazena valor numérico para lógica e envio
      });
    } else if (name === 'DESCONTO') {
      // Permite apenas números e vírgula
      const formatted = value.replace(/[^0-9,]/g, '');
      setForm({ ...form, [name]: formatted });
    } else {
      setForm({ ...form, [name]: value });
    }
    
    setTouched({ ...touched, [name]: true });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.prefeitura) newErrors.prefeitura = 'Campo obrigatório';
    // Validar o valor numérico armazenado
    if (form.valorContratoNumeric <= 0) newErrors.valorContrato = 'Informe um valor válido e maior que zero';
    if (form.DESCONTO && (isNaN(parseFloat(form.DESCONTO.replace(',', '.'))) || parseFloat(form.DESCONTO.replace(',', '.')) < 0)) {
      newErrors.DESCONTO = 'Informe uma DESCONTO válida';
    }
    // descrição pode ser opcional, mas pode validar tamanho se quiser
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        
       
        const payload = {
          CON_PRE_ID: parseInt(form.prefeitura),
          CON_VALOR: form.valorContratoNumeric,
          CON_DESCONTO: form.DESCONTO ? parseFloat(form.DESCONTO.replace(',', '.')) : null,
          CON_DESCRICAO: form.descricao || null
        };

        const response = await api.post(API_CONFIG.ENDPOINTS.CONTRATO.CADASTRAR_CONTRATO, payload);

        if (response.data.status) {
          message.success(response.data.message || 'Contrato cadastrado com sucesso!');
          setForm(initialState);
          setTouched({});
          setSubmitted(false);
        } else {
          message.error(response.data.message || 'Erro ao cadastrar contrato');
        }
      } catch (error) {
       // console.error('Erro ao cadastrar contrato:', error);
        if (error.response?.status === 401) {
          message.error('Sessão expirada. Por favor, faça login novamente.');
        } else if (error.response?.status === 422) {
          message.error(error.response.data.message || 'Dados inválidos. Verifique os campos preenchidos.');
        } else {
          message.error(error.response?.data?.message || 'Erro ao cadastrar contrato');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const showError = (field) => (submitted || touched[field]) && errors[field];

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Cadastrar Contrato</h1>
        <div className="modal-content">
          <form className="form-contrato" onSubmit={handleSubmit} autoComplete="off">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Prefeitura <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="prefeitura"
                  value={form.prefeitura}
                  onChange={handleChange}
                  className={showError('prefeitura') ? 'erro' : ''}
                  disabled={loadingPrefeituras}
                >
                  <option value="">Selecione a Prefeitura</option>
                  {prefeituras.map(prefeitura => (
                    <option key={prefeitura.id} value={prefeitura.id}>
                      {prefeitura.nome}
                    </option>
                  ))}
                </select>
                {showError('prefeitura') && <span className="msg-erro">{errors.prefeitura}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Valor do Contrato <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="valorContrato"
                  placeholder="0,00"
                  value={form.valorContrato}
                  onChange={handleChange}
                  className={showError('valorContrato') ? 'erro' : ''}
                  inputMode="decimal"
                  disabled={loading}
                />
                {showError('valorContrato') && <span className="msg-erro">{errors.valorContrato}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">DESCONTO (%)</label>
                <input
                  type="text"
                  name="DESCONTO"
                  placeholder="Ex: 10,5"
                  value={form.DESCONTO}
                  onChange={handleChange}
                  className={showError('DESCONTO') ? 'erro' : ''}
                  inputMode="decimal"
                  disabled={loading}
                  maxLength={6}
                />
                {showError('DESCONTO') && <span className="msg-erro">{errors.DESCONTO}</span>}
              </div>
            </div>
            <div className="form-group" style={{ marginTop: 16 }}>
              <label className="form-label">Descrição</label>
              <textarea
                name="descricao"
                placeholder="Descrição do contrato"
                value={form.descricao}
                onChange={handleChange}
                className={showError('descricao') ? 'erro' : ''}
                disabled={loading}
                maxLength={500}
                rows={4}
                style={{ width: '100%', resize: 'vertical' }}
              />
              {showError('descricao') && <span className="msg-erro">{errors.descricao}</span>}
            </div>
            <div className="form-actions">
              <button 
                type="submit" 
                className="cadastro-submit-button"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 